/** @format */
import { HoneycombWebSDK } from '@honeycombio/opentelemetry-web';
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';

const COOKIE_NAME = 'swimlane_as_exp_dsg';

function getSwimlaneAsExpDsgCookie(): number | undefined {
	if (typeof document === 'undefined') return undefined;
	const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${COOKIE_NAME}=([^;]*)`));
	if (!match) return undefined;
	const value = decodeURIComponent(match[1]);
	const num = Number(value);
	return isNaN(num) ? undefined : num;
}

const configDefaults = {
	ignoreNetworkEvents: true,
	propagateTraceHeaderCorsUrls: [
		// Regex to match your backend URLs. Update to the domains you wish to include.
		// eslint-disable-next-line no-useless-escape
		/https:\/\/(?!(aem\.))[^\/]*\.(dickssportinggoods|publiclands|golfgalaxy|goinggoinggone)\.com/
	]
};

export function startHoneycomb(
	apiKey = '',
	serviceName = '',
	appName = '',
	brand = ''
): HoneycombWebSDK {
	const swimlaneCookie = getSwimlaneAsExpDsgCookie();
	const sdk = new HoneycombWebSDK({
		// endpoint: "https://api.eu1.honeycomb.io/v1/traces", // Send to EU instance of Honeycomb. Defaults to sending to US instance.
		debug: true, // Set to false for production environment.
		apiKey: apiKey, // Replace with your Honeycomb Ingest API Key.
		serviceName: serviceName, // Replace with your application name. Honeycomb uses this string to find your dataset when we receive your data. When no matching dataset exists, we create a new one with this name if your API Key has the appropriate permissions.
		resourceAttributes: {
			'app.name': appName || 'unknown',
			'brand.name': brand || 'unknown',
			'swimlane.id': swimlaneCookie || 'unknown'
		},
		instrumentations: [
			getWebAutoInstrumentations({
				// Loads custom configuration for xml-http-request instrumentation.
				'@opentelemetry/instrumentation-xml-http-request': configDefaults,
				'@opentelemetry/instrumentation-fetch': configDefaults,
				'@opentelemetry/instrumentation-document-load': configDefaults
			})
		]
	});
	sdk.start();
	return sdk;
}
